export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
          {/* 关于我们 */}
          <div>
            <h3 className="text-white font-semibold mb-4">关于我们</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  团队介绍
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  联系我们
                </a>
              </li>
            </ul>
          </div>

          {/* 产品服务 */}
          <div>
            <h3 className="text-white font-semibold mb-4">产品服务</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  选品服务
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  活动搭建
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  精准投放
                </a>
              </li>
            </ul>
          </div>

          {/* 帮助支持 */}
          <div>
            <h3 className="text-white font-semibold mb-4">帮助支持</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  使用文档
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  常见问题
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  技术支持
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* 底部版权信息 */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-400 mb-4 md:mb-0">
              © {currentYear} CLC 营销平台. 保留所有权利.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">
                隐私政策
              </a>
              <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">
                服务条款
              </a>
              <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">
                使用协议
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

